import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function PaymentSuccess() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.paymentStatus(sessionId);
        if (data.payment_status === "paid") { await refresh(); setStatus("paid"); return; }
        if (data.status === "expired" || attempts > 10) { setStatus("error"); return; }
      } catch (e) { if (attempts > 10) { setStatus("error"); return; } }
      setTimeout(poll, 2000);
    };
    poll();
  }, [refresh]);

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-6 text-center">
      {status === "checking" && (<><Loader2 className="animate-spin text-red-500" size={48} /><p className="mt-4 text-zinc-400">Verifica pagamento...</p></>)}
      {status === "paid" && (<>
        <CheckCircle2 className="text-emerald-500" size={64} />
        <h1 className="mt-4 font-display text-3xl font-extrabold uppercase text-white">Abbonamento attivo! 💪</h1>
        <p className="mt-2 text-zinc-400">Ora hai accesso completo a VOLT.</p>
        <button onClick={() => navigate("/")} className="mt-6 rounded-full bg-red-500 px-6 py-3 font-semibold text-white hover:bg-red-600">Inizia ad allenarti</button>
      </>)}
      {status === "error" && (<>
        <XCircle className="text-red-500" size={64} />
        <h1 className="mt-4 font-display text-2xl font-extrabold uppercase text-white">Qualcosa è andato storto</h1>
        <button onClick={() => navigate("/pricing")} className="mt-6 rounded-full bg-red-500 px-6 py-3 font-semibold text-white hover:bg-red-600">Riprova</button>
      </>)}
    </div>
  );
}

export function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-6 text-center">
      <XCircle className="text-zinc-500" size={64} />
      <h1 className="mt-4 font-display text-2xl font-extrabold uppercase text-white">Pagamento annullato</h1>
      <button onClick={() => navigate("/pricing")} className="mt-6 rounded-full bg-red-500 px-6 py-3 font-semibold text-white hover:bg-red-600">Torna agli abbonamenti</button>
    </div>
  );
}
